module.exports = __webpack_public_path__ + "img/pleisure_bodyimage05.44ef4da9.jpg";